import { network } from '@utils'

import { handleReturn } from '../root'

type FeaturebaseJwtResponse = {
  token: string
}

export const fetchFeaturebaseJwt = async (): Promise<FeaturebaseJwtResponse> => {
  const url = '/v1/integrations/featurebase/jwt/'
  const { data: responseData, status } = await network.httpClient.request({
    url,
    method: 'POST',
    validateStatus: () => true
  })

  return handleReturn<FeaturebaseJwtResponse>({ data: responseData, status })
}
